import { render, staticRenderFns } from "./BetaTesterForm.vue?vue&type=template&id=20683fe0"
import script from "./BetaTesterForm.vue?vue&type=script&lang=js"
export * from "./BetaTesterForm.vue?vue&type=script&lang=js"
import style0 from "./BetaTesterForm.vue?vue&type=style&index=0&id=20683fe0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports